document.addEventListener('variant:change', function (event) {
  // Sur mobile, on laisse Impact fonctionner normalement
  if (window.innerWidth < 1000) return;

  const variant = event.detail.variant;

  if (!variant || !variant.featured_media) return;

  const mediaId = String(variant.featured_media.id);
  const section = event.target.closest('.shopify-section');

  if (!section) return;

  setTimeout(function () {
    // On cible UNIQUEMENT les petites vignettes de navigation Impact
    const thumbnail = section.querySelector(
      `product-gallery-navigation .product-gallery__thumbnail[data-media-id="${mediaId}"]`
    );

    if (thumbnail) {
      thumbnail.click();
    }
  }, 150);
});
// ======================================================
// IMPACT - MASQUER LES COULEURS INCOMPATIBLES
// ET CORRIGER AUTOMATIQUEMENT LA SÉLECTION
// ======================================================

(function () {
  let correctionRunning = false;

  function getMainColorInputs() {
    return Array.from(
      document.querySelectorAll(
        'input[type="radio"][data-option-position="2"][form]'
      )
    ).filter(function (input) {
      const form = input.getAttribute('form') || '';

      // On ne garde que le vrai formulaire produit principal
      return form.includes('__main');
    });
  }

  function getLabel(input) {
    if (!input || !input.id) return null;

    return document.querySelector(
      `label[for="${CSS.escape(input.id)}"]`
    );
  }

  function isUnavailable(input) {
    const label = getLabel(input);

    if (!label) return false;

    // Important :
    // Orange peut avoir input.disabled = false
    // mais label.is-disabled = true
    return (
      input.disabled ||
      label.classList.contains('is-disabled')
    );
  }

  function syncColors() {
    if (correctionRunning) return;

    const inputs = getMainColorInputs();

    if (!inputs.length) return;

    // 1. Masquer / réafficher les couleurs
    inputs.forEach(function (input) {
      const label = getLabel(input);

      if (!label) return;

      if (isUnavailable(input)) {
        label.style.setProperty(
          'display',
          'none',
          'important'
        );
      } else {
        label.style.removeProperty('display');
      }
    });

    // 2. Vérifier la couleur actuellement sélectionnée
    const selected = inputs.find(function (input) {
      return input.checked;
    });

    if (!selected) return;

    // Elle reste valide : rien à faire
    if (!isUnavailable(selected)) return;

    // 3. Chercher la première couleur réellement disponible
    const replacement = inputs.find(function (input) {
      return !isUnavailable(input);
    });

    if (!replacement || replacement === selected) return;

    const replacementLabel = getLabel(replacement);

    if (!replacementLabel) return;

    correctionRunning = true;

    // Simulation d'un vrai clic utilisateur
    replacementLabel.click();

    setTimeout(function () {
      correctionRunning = false;
      syncColors();
    }, 200);
  }

  function scheduleSync() {
    setTimeout(syncColors, 50);
    setTimeout(syncColors, 200);
    setTimeout(syncColors, 500);
  }

  // Changements utilisateur
  document.addEventListener('change', scheduleSync);

  // Changements de variante Impact
  document.addEventListener('variant:change', scheduleSync);

  // Impact modifie dynamiquement is-disabled / disabled
  const observer = new MutationObserver(function (mutations) {
    const relevant = mutations.some(function (mutation) {
      return (
        mutation.type === 'childList' ||
        mutation.attributeName === 'class' ||
        mutation.attributeName === 'disabled'
      );
    });

    if (relevant) {
      scheduleSync();
    }
  });

  observer.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'disabled']
  });

  // Premier passage
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      scheduleSync
    );
  } else {
    scheduleSync();
  }
})();
